import React from 'react';

const Artworks = () => (
  <div>
    <h2>Apps</h2>
    <p>Unicode to Tamil</p>
    <p>Get it in <a href='https://play.google.com/store/apps/details?id=com.mrgreenstudio.unicodetotamil'>Play Store</a>.</p>
  </div>
);

export default Artworks;
